import React from 'react';
import { Outlet } from 'react-router-dom';
import HeaderEN from './HeaderEN';
import FooterEN from './FooterEN';
import WelcomePopupEN from './WelcomePopupEN';
import BackgroundEffects from '../BackgroundEffects';
import LiveIndicator from '../LiveIndicator';
import SupportWidget from '../SupportWidget';

const ENLayout = () => {
  return (
    <>
      <BackgroundEffects />
      <WelcomePopupEN />
      <HeaderEN />
      <Outlet />
      <FooterEN />
      <LiveIndicator />
      <SupportWidget />
    </>
  );
};

export default ENLayout;
